const UrqlSelectionSetKeyDict = {
  AccountDetailBalanceGroup: () => null,
  AccountDetailItem: () => null,
  ActivatedOffersPageError: () => null,
  Address: () => null,
  AgreementResource: () => null,
  AnalyticsEvent: () => null,
  AnalyticsEventProperty: () => null,
  AppleInAppWalletProvisioningError: () => null,
  Badge: () => null,
  BillManagerQualificationResult: () => null,
  ButtonComponent: () => null,
  CacheableURL: () => null,
  CallUsPageSuccess: () => null,
  CardReviewDetailsSuccess: () => null,
  CashbackDetails: () => null,
  Category: () => null,
  ChartScale: () => null,
  ChartScaleLabel: () => null,
  ChatContentHtml: () => null,
  ChatContentLexBotOption: () => null,
  ChatContentMessage: () => null,
  ChatAvailabilitySuccess: () => null,
  ContentList: () => null,
  CopyValue: () => null,
  CustomerChatMessage: () => null,
  CustomerChatSessionNotFound: () => null,
  Email: () => null,
  FloatType: () => null,
  FullName: () => null,
  GeoCoordinate: () => null,
  HomeTilesNavigationButtonConfiguration: () => null,
  IconText: () => null,
  Institution: () => null,
  Money: () => null,
  MoveMoneyTiles: () => null,
  MyAccounts: () => null,
  MyCashbackComponentError: () => null,
  MyPartnerOffers: () => null,
  MyOffersComponentError: () => null,
  OnboardingCard: () => null,
  PartnerOfferTile: () => null,
  PlaidAccountLinkToken: () => null,
  PresignedUploadFormField: () => null,
  RdcStatusType: () => null,
  RouteNavigationAction: () => null,
  OpenURLNavigationAction: () => null,
  SDInlineAlert: () => null,
  SDProductStatusRowComponent: () => null,
  ShippingInformationV2: () => null,
  SLBarDataSeries: () => null,
  SLBarGraphData: () => null,
  SLCalloutBanner: () => null,
  SLFilterListDataView: () => null,
  Tag: () => null,
  SLLineDataPoint: () => null,
  SmartChartData: () => null,
  SmartViewDataView: () => null,
  SmartViewNavigationAction: () => null,
  SuggestedAddress: () => null,
  TaxFilingLinkSuccess: () => null,
  TransferNotPossibleError: () => null,
  TransferReviewDetails: () => null,
  TransferReviewDetailsError: () => null,
  TransferReviewSection: () => null,
  VxlListItemTrailingTextAccessory: () => null,
  Transfer: () => null,
  TitledAmount: () => null,
  User: () => null,
  UserAvatar: () => null,
  UserVoice: () => null,
  CategoryViewSuccess: () => null,
  CategoryViewError: () => null,
  VaroAdvanceProductsNotQualified: () => null,
  VaroAdvanceEligibilityNotQualified: () => null,
  VXLAccountCardSquare: () => null,
  VXLButton: () => null,
  VXLCardNudge: () => null,
  VXLIconType: () => null,
  VXLText: () => null,
  VXLTextStyle: () => null,
  VXLTracker: () => null,
  VXLTrackerCard: () => null,
  VxlListItem: () => null,
  VxlSectionDivider: () => null,
  SLLineGraphData: () => null,
  SLLineDataSeries: () => null,
  SLFilterItemDataView: () => null,
  SLBarSegment: () => null,
  SmartViewError: () => null,
  SurveySuccess: () => null,
  TransactionDetailCopyItem: () => null,
  TransactionDetailDateItem: () => null,
  GenericTransactionDetailGroup: () => null,
  DisputeEligibility: () => null,
  MyNotificationPreferences: () => null,
  Link: () => null,
  LocalOfferLocation: () => null,
  MapData: () => null,
  State: () => null,
  ValidAddress: () => null,
  CardNumberSuccess: () => null,
  CardNumberError: () => null,
  CardNumberChallenge: () => null,
  CardNumberChallengeItem: () => null,
  CardNumberDecline: () => null,
  SelectChallengeSuccess: () => null,
  SelectChallengeError: () => null,
  AcceptChallengeSuccess: () => null,
  AcceptChallengeError: () => null,
  V2ATransferDetailGroup: () => null,
  NotificationPreferenceGroup: () => null,
  VaroAdvanceProductsQualified: () => null,
  ExternalTransferSource: () => null,
  ForTransferSource: () => null,
  VaroAdvanceRepaymentDates: () => null,
  AccountVisibility: () => null,
  CreditScoreNoScore: () => null,
  CreditScoreRange: () => null,
  LineOfCreditDetailsResult: () => null,
  GenericTransactionDetailItem: () => null,
  LineOfCreditInstallmentsData: () => null,
  LineOfCreditInstallment: () => null,
  InternalChargeCardAccount: () => null,
  ChargeCardAction: () => null,
  ChargeCardAccountDetailPaymentGroup: () => null,
  CardBalanceAttribute: () => null,
  ChargeCardPaymentDue: () => null,
  ChargeCardAutoPaymentSettings: () => null,
  LineOfCreditPaymentDetailSuccess: () => null,
  AccountDetailForSelector: () => null,
  LineOfCreditPaymentView: () => null,
  LineOfCreditDetailBanner: () => null,
  StatementGroup: () => null,
  LineOfCreditHistorySuccess: () => null,
  LineOfCreditHistorySection: () => null,
  LineOfCreditHistorySectionItem: () => null,
  LineOfCreditHistoryDetailsSuccess: () => null,
  LineOfCreditTransactionView: () => null,
  EducationalScreenV2: () => null,
  IconTextComponent: () => null,
  VXLIllustrationType: () => null,
  GroupedAccounts: () => null,
  TransferOptions: () => null,
  TransferInfo: () => null,
  AccountDetailInterestGroup: () => null,
  TransferInfoAction: () => null,
  AccountDetailCopyItemGroup: () => null,
  AccountDetailMoneyItemGroup: () => null,
  RemoveExternalCardInfo: () => null,
  ExternalCardsNotFound: () => null,
  ButtonComponentV2: () => null,
  Licenses: () => null,
  ExternalCardAddress: () => null,
  WebLicenses: () => null,
  WebTabaPayConfig: () => null,
  ExternalCardSuccess: () => null,
  VerifyCardActionScreen: () => null,
  SDContinueClientFlowAction: () => null,
  SelfFundedOfferComponentsError: () => null,
  FlowMetadata: () => null,
  DiscoverMoreProductRowTile: () => null,
  DebtSaleDetailsError: () => null,
  DebtSaleAccountDetailsError: () => null,
  DebtSalePaymentButton: () => null,
  DebitCardFundingOptionsSuccess: () => null,
};

export default UrqlSelectionSetKeyDict;
